import React from "react";
import styles from "./policy.module.scss";

import moment from "moment";

const pipPolicy = props => {
  const { stage1VisitedOn, language, threshold } = props.match.params;
  const formattedDate = moment(parseInt(stage1VisitedOn)).format("DD-MM-YYYY");

  const deadlineDate = moment(parseInt(stage1VisitedOn))
    .add(14, "days")
    .format("DD-MM-YYYY");

  if (language && language === "en") {
    return (
      <div className={styles.container}>
        <h3>Acknowledgement of Improvement Plan</h3>

        <p>
          You have been placed under an Improvement Plan due to low performance
          in your recent evaluation starting from {formattedDate}. Please focus
          on improving your weekly score above the threshold {threshold}. Watch
          the training videos given in your Improvement Plan before the{" "}
          {deadlineDate} deadline. If your performance does not improve, your
          case will move to the next stage of the plan.
        </p>

        <h4>About the Improvement Plan:</h4>
        <ul>
          <li>Performance is checked every Friday morning.</li>
          <li>
            If weekly score &lt; score cutoff, you move to the next stage.
          </li>
          <li>
            If weekly score ≥ score cutoff for one week, you return to Stage 0.
          </li>
          <li>{"You'll get notifications when your stage changes."}</li>
          <li>Trainers and Ops team will guide you to improve performance.</li>
        </ul>
      </div>
    );
  } else if (language && language === "hi") {
    return (
      <div className={styles.container}>
        <h3>सुधार योजना की स्वीकृति</h3>

        <p>
          आपके हालिया मूल्यांकन में कम प्रदर्शन के कारण आपको {formattedDate} से
          <b> सुधार योजना (Improvement Plan) </b>के अंतर्गत रखा गया है।{" "}
        </p>
        <p>
          कृपया अपना साप्ताहिक स्कोर न्यूनतम सीमा <b>{threshold}</b> से ऊपर लाने
          पर ध्यान दें।
          <b>{deadlineDate}</b> की समय-सीमा से पहले अपनी सुधार योजना में दिए गए
          सभी प्रशिक्षण वीडियो अवश्य देखें।{" "}
        </p>
        <p>
          {" "}
          यदि आपके प्रदर्शन में सुधार नहीं होता है, तो आपका मामला योजना के अगले
          चरण में भेज दिया जाएगा।
        </p>

        <h4>सुधार योजना के बारे में:</h4>
        <ul>
          <li>प्रदर्शन की जाँच प्रत्येक शुक्रवार सुबह की जाती है।</li>
          <li>
            यदि साप्ताहिक स्कोर <b> कटऑफ स्कोर से कम </b>होता है, तो आप अगले चरण
            में चले जाएँगे।
          </li>
          <li>
            यदि साप्ताहिक स्कोर{" "}
            <b>एक सप्ताह के लिए कटऑफ स्कोर के बराबर या उससे अधिक </b> रहता है,
            तो आप <b>स्टेज 0</b> में वापस आ जाएँगे।
          </li>
          <li>
            स्टेज में किसी भी बदलाव की सूचना आपको नोटिफिकेशन के माध्यम से दी
            जाएगी।
          </li>
          <li>
            प्रदर्शन सुधारने में आपकी सहायता के लिए{" "}
            <b> ट्रेनर्स और ऑप्स टीम </b>आपका मार्गदर्शन करती रहेगी।
          </li>
        </ul>
      </div>
    );
  }
};

export default pipPolicy;
